module.exports = {
  mmzs: '비고: 트 레이스 시스템 이 PAD 비밀 번 호 를 가지 고 있 기 때문에 모든 특수 문 자 를 지원 하지 않 습 니 다. 트 레이스 시스템 계 정 비밀 번 호 를 리 셋 할 때 특수 문 자 는 # 또는 @ 만 사용 할 수 있 습 니 다',
  mqzwdbcl: '지금처리할일이없습니다！',
  cxyzzjjkfz: '프로그래머가긴급개발중이니서두르지마 십시오！',
  yhtymh: '바다를이기고문호를통일하다',
  thtymhqxqbxt: '이해통일문호산하모든시스템',
  ghbj: '배경 을 바꾸다',
  hymr: '환원 기본 값',
  ckgd: '더 보기',
  qd: '확정',
  qr: '확인',
  qx: '취소',
  tc: '출구',
  czcg: '작업이 성공하다',
  wxts: '훈시 (훈시)',
  cw: '오류',
  jg: '경고',
  // 登录页
  loginPage: {
    qhqyzm: '인증번호받으세요',
    tysfglpt: '문호시스템을통일하다',
    zhdl: '계좌 번호를 등록하다.',
    yhmygbh: '사용자 이름/직원 번호',
    sjhm: '핸드폰 번호',
    xgmm: '비밀번호 변경',
    mm: '암호',
    qxgcsmm: '초기 비밀번호를 수정하십시오.',
    mmydqqxgmm: '암호가 만료되었습니다. 암호를 수정하십시오',
    xmmbnyjmmxt: '새비밀번호는이전비밀번호와같을수없다',
    xmm: '새 비밀번호',
    ymm: '원 비밀번호',
    qrxmm: '새 비밀번호 확인',
    wjmm: '비밀번호를 잊어버리다',
    xyhddl: '오른쪽으로 미끄러짐 로그인',
    yzcg: '성공적으로 검증',
    smdl: '로그인 스톱',
    qywxsm: '기업 웨이신 스퍼',
    ddsm: '리드를 박다',
    ewmysx: '이중코드는 이미 효력을 상실하였다.',
    sxewm: '새 이중부호',
    dxyzm: '문자메시지 인증번호',
    hqyzm: '인증 코드 가져오기',
    xyb: '다음 단계',
    dlsjyz: '로그인 휴대폰검증',
    wbll: '외부 링크',
    bq: '저작권',
    mmbyz: '암호가 일치하지 않습니다.',
    hcxhq: '다시 가져오기',
    qxsrzqdsjhm: '먼저 정확한 휴대 전화 번호를 입력하세요',
    qsrdxyzm: '문자 인증번호를 입력해주세요',
    qsryhm: '사용자 이름을 입력하십시오.',
    qxzsjhm: '핸드폰 번호를 선택하세요',
    fscg: '성공적으로 보내기',
    yhmbnwk: '사용자 이름이 비어 있을 수 없음',
    yhmwgzf: '사용자 이름은 3-12 글자입니다.',
    yhmbnczkg: '사용자 이름/직원 번호에는 공백 없이 사용할 수 없습니다',
    mmbnwk: '암호가 비어 있지 않습니다',
    ymmbnwk: '원래의 비밀번호가 비어 있을 수 없습니다',
    mmwsfzhlw: '비밀번호는 신분증 마지막 6자리',
    mmzswzmsztszf: '비밀번호는 적어도 10자, 숫자, 특수 문자 조합입니다',
    mmzswzmsztszfnew: '비밀번호는 적어도 10자, 숫자, 특수 문자 조합입니다，특수 문 자 는 # 또는 @ 만 사용 할 수 있 습 니 다.'
  },
  // 首页
  homePage: {
    ty: '태국어',
    hy: '한국어',
    gh: '직원 번호',
    zh: '계정',
    gw: '일자리를',
    sj: '휴대폰',
    yx: '메일 박스',
    yy: '언어',
    pf: '피부',
    bj: '배경',
    yh: '대리하다',
    xtyyxz: '시스템 언어 선택',
    zwjt: '중국어 간체',
    zwft: '중국어 번체',
    yw: '영어',
    qb: '전부',
    wdyy: '응용 프로그램으로',
    dlbjxgqh: '로그인 배경 효과 켬/끔',
    zjbj: '중간 배경',
    ybbj: '오른쪽 배경',
    qhdlr: '대리인 켬/끔',
    xtpfqh: '시스템 스킨 전환기',
    oa: 'OA',
    fkxt: '비용 제어',
    hwcrm: '비 대륙 CRM',
    hr: 'HR',
    crm: '대륙 CRM',
    zj: '증명서 알림',
    srm: 'SRM'
  },
  // 后台返回信息
  interface: {
    dlsx: '로그인 실효됨',
    dlsxqcxdl: '로그인할 수 없습니다. 다시 로그인하십시오.',
    fail: 'code 반환 실패',
    404: '네트워크 이상',
    '0000': '잘못을 묵인하다',
    1000: '인자 오류',
    2000: '동시 HR 조직 또는 부서 실패',
    3000: '시스템 이름 존재함',
    3001: '설치한 직원이 있어서 삭제할 수 없습니다',
    3002: '메시지 플랫폼 이상',
    8001: '웨이신 사용자 가져오기 실패',
    9997: '로그인 실효됨',
    9998: '불법으로 청구하다',
    9999: '시스템 오류',
    10001: '이름이 이미 존재합니다.',
    // 10021: '唯一标识已存在',
    10002: '작동 실패',
    10003: '직원 번호가 이미 존재합니다.',
    10004: '직원 번호:순 숫자',
    10005: '핸드폰 번호:비정상적인 핸드폰 번호',
    10006: '비밀번호:8-16자리수 문자',
    10007: '신분증 번호:잘못된 입력',
    10008: '여권증명번호:정확하지 않은 입력',
    10009: '메일박스:잘못된 형식',
    10010: '암호가 틀렸습니다.',
    10011: '계정 이름이나 암호가 잘못되었습니다. 로그인 실패',
    10012: '계정 이름이 존재하지 않음',
    10013: '사용자 로그인 만료됨',
    10014: '연속 로그인 실패로 인하여 계정이 잠겨 있습니다.',
    10015: '인증번호가 올바르지 않습니다',
    10016: '핸드폰번호가 유효하지 않습니다.',
    10017: '인증번호가 이미 시간 초과되었습니다',
    10018: '잘못된 코드입니다. 다시 시도하십시오.',
    10019: '매일 같은 핸드폰번호 인증번호 3번만 발송 가능',
    10020: '인증 코드발송에 실패했습니다.',
    10021: '자동 로그인 실패',
    10022: '로그인이 5번 이상 실패하였습니다. 인증번호를 입력하십시오',
    10023: '그림 서버를 업로드하는 데 실패했습니다.',
    10024: '현재 스탭이 있습니다. 삭제할 수 없습니다!',
    10025: '현재 조직이 부서입니다. 삭제할 수 없습니다!',
    10026: '현재 조직이 자회사를 가지고 있습니다. 삭제할 수 없습니다!',
    10027: '현재 하위 부서가 있습니다. 삭제할 수 없습니다!',
    10028: '핸드폰번호가 이미 존재합니다.',
    10029: '증명번호가 이미 존재합니다.',
    10030: '편지함이 이미 존재합니다.',
    10031: '선택한 부서는 하급 부서로 존재하기에 삭제할수 없다!',
    10032: '로그인 비밀번호가 이미 만료되었습니다."기업 위챗"또는"암호 잊기"를 눌러 비밀번호를 다시 설정하십시오.',
    10033: '%s (으) 로의 로그인 비밀번호가 아직 만료되지 않았습니다. 즉시 비밀번호를 수정하시기 바랍니다.',
    10034: '처음 로그인하시니, 먼저 암호를 수정하시기 바랍니다.',
    10035: '선택한 어플리케이션이 인용되었습니다. 삭제할 수 없습니다!',
    10036: '선택한 역할을 인용한 것으로 보입니다. 삭제할 수 없습니다!',
    10037: '현재 조직이 존재합니다. 삭제할 수 없습니다!',
    10038: '링크 주소가 이미 존재합니다.',
    10039: '오류%s 번 계정을 다시 입력하면 잠깁니다!',
    10040: '비밀번호는 적어도 8자, 숫자, 특수 문자 조합입니다'
  }
}
